import AccountsMarketplaceProducts from 'modules/AccountsMarketplace/Products/Products'
import Sagas from 'modules/AccountsMarketplace/Products/saga'
import Reducer from 'modules/AccountsMarketplace/Products/reducer'

export { Sagas, Reducer }

export default AccountsMarketplaceProducts
